import { ExternalLink, Text } from "@clipboard-health/ui-react";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { Box, Button } from "@mui/material";

import { APP_V2_USER_EVENTS, logEvent } from "../lib/analytics";
import { FACILITY_HELP_SUPPORT_LINK } from "./paths";

export function ExternalHelpCenterLinkButton() {
  return (
    <Box>
      <Button
        variant="outlined"
        startIcon={<OpenInNewOutlinedIcon />}
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.HELP_CENTER_EXTERNAL_LINK_CLICKED);
        }}
      >
        <ExternalLink to={FACILITY_HELP_SUPPORT_LINK} underline="none">
          <Text variant="h3">Check out more articles</Text>
        </ExternalLink>
      </Button>
    </Box>
  );
}
